import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useUI } from '../../DataStore/UIContext';
import { useAuth } from '../../DataStore/AuthContext';

const Sidebar = () => {
  const { sidebarHidden, sidebarOpen, toggleSidebar } = useUI();
  const {user} = useAuth();
 
  return (
    <div className={`main-sidebar main-sidebar-sticky side-menu ${sidebarHidden ? 'hidden' : ''} ${sidebarOpen ? 'open' : ''}`}>
      <div className="sidemenu-logo">
        <Link className="main-logo" to="/">
          <img src={process.env.PUBLIC_URL + "/assets/img/brand/logo.png"} className="header-brand-img desktop-logo" alt="logo" />
          <img src={process.env.PUBLIC_URL + "/assets/img/brand/icon.png"} className="header-brand-img icon-logo" alt="icon" />
          <img src={process.env.PUBLIC_URL + "/assets/img/brand/logo-light.png"} className="header-brand-img desktop-logo theme-logo" alt="logo-light" />
          <img src={process.env.PUBLIC_URL + "/assets/img/brand/icon-light.png"} className="header-brand-img icon-logo theme-logo" alt="icon-light" />
        </Link>
       
         {/* Menu collapse icon */}
         <span className="mobile-header-menu-icon link" id="mainSidebarToggle" onClick={toggleSidebar}>
            <span></span>
          </span>
      </div>
      <div className="main-sidebar-body">
        <ul className="nav">
          <li className="nav-label">Dashboard</li>

          {user?.role?.role_name !== 'Billing' && (
            <>
          <li className="nav-item">
            <NavLink className="nav-link" to="/dashboard" exact="true">
              <i className="fe fe-airplay"></i>
              <span className="sidemenu-label">Dashboard</span>
            </NavLink>
          </li>
            </>
          )}
          {user?.role?.role_name === "Billing" && (
            <>
           <li className="nav-item">
            <NavLink className="nav-link" to="/dashboard" exact="true">
              <i className="fe fe-airplay"></i>
              <span className="sidemenu-label">Dashboard</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/vouchers" exact="true">
              <i className="fe fe-tag"></i>
              <span className="sidemenu-label">Vouchers</span>
            </NavLink>
          </li>
            </>
          )}

          {user?.role?.role_name !== 'Billing' && (
            <>
          <li className="nav-label">Access Management</li>
        
          <li className="nav-item">
            <NavLink className="nav-link" to="/wifi-plans">
              <i className="fe fe-layers"></i>
              <span className="sidemenu-label">Wifi Plans</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/voucher-mgt">
              <i className="fe fe-tag"></i>
              <span className="sidemenu-label">Vouchers</span>
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/voucher-usage">
              <i className="fe fe-clock"></i>
              <span className="sidemenu-label">Voucher Usage</span>
            </NavLink>
          </li>

        <li className="nav-label">Payments</li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/mobile-money">
              <i className="fe fe-credit-card"></i>
              <span className="sidemenu-label">Mobile Money</span>
            </NavLink>
          </li>
           <li className="nav-item">
            <NavLink className="nav-link" to="/sales-report">
              <i className="fe fe-trending-up"></i>
              <span className="sidemenu-label">Sales Report</span>
            </NavLink>
          </li>
           <li className="nav-item">
            <NavLink className="nav-link" to="/sales-agents">
              <i className="fe fe-users"></i>
              <span className="sidemenu-label">Sales Agents</span>
            </NavLink>
          </li>


         <li className="nav-label">Device Management</li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/network-users">
              <i className="fe fe-globe"></i>
              <span className="sidemenu-label">Network Devices</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/network-device">
              <i className="fe fe-smartphone"></i>
              <span className="sidemenu-label">Device Profile</span>
            </NavLink>
          </li>
            </>
          )}


      {user?.role?.is_admin === true && (
        <>
        <li className="nav-label">Configuration</li>

          <li className="nav-item">
            <NavLink className="nav-link" to="/settings">
              <i className="fe fe-settings"></i>
              <span className="sidemenu-label">Settings</span>
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/license">
              <i className="fe fe-shield"></i>
              <span className="sidemenu-label">Billing & License</span>
            </NavLink>
          </li>
        </>
      )}

        </ul>
      </div>
    </div>
  );
};

export default Sidebar;